export class TableauMessages {
  public research = 'table.research';
  public firstPage = 'table.firstPage';
  public previousPage = 'table.previousPage';
  public nextPage = 'table.nextPage';
  public lastPage = 'table.lastPage';
  public itemsPerPage = 'table.itemsPerPage';
  public of = 'table.of';
  public separator = 'table.separator';
  public results = 'table.results';
  public total = 'table.total';
  public consult = 'table.consult';
  contentTitle = 'modal.contentTitle';
  footerTitle = 'modal.footerTitle';
  public nonCorformeMessage = 'modal.nonCorformeMessage';
  public noData = 'table.noData';

  constructor() {
  }
}
